export function buildDomainReportScanUrl(domain: string, scanId?: string): string {
  const domainSlug = encodeURIComponent(domain)

  if (!scanId) {
    return `/domains/${domainSlug}/ai-report`
  }

  const params = new URLSearchParams({
    domain,
    scanId,
  })

  return `/domains/${domainSlug}/ai-report?${params.toString()}`
}

export function getLaunchedScanParams(searchParams: URLSearchParams): { domain: string; scanId: string } | null {
  const domain = searchParams.get('domain')
  const scanId = searchParams.get('scanId')

  if (!domain || !scanId) {
    return null
  }

  return { domain, scanId }
}
